// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const ControlBar = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
`;
ControlBar.displayName = 'S.ControlBar';

export const SelectJobVersionSize = styled.div`
  width: 200px;
`;
SelectJobVersionSize.displayName = 'S.SelectJobVersionSize';

export const ButtonToRight = styled.div`
  flex: 1 1 auto;
  text-align: right;
`;
ButtonToRight.displayName = 'S.ButtonToRight';

export const ClipOverflow = styled.div`
  text-overflow: clip;
`;
ClipOverflow.displayName = 'S.ClipOverflow';
